import type { AuditLogEntry } from '../types';

import { summarizeAccess, summarizeInvite } from './access';
import { summarizeDelete, summarizeDiff, summarizeSet } from './diff';
import { summarizeFacts } from './facts';
import { summarizeFailure } from './failure';
import { summarizeRequestEcho } from './request';
import type { AuditSummary } from './types';

/**
 * Tried in order; the first that applies wins. Invites come before the diff because
 * they record the resulting access as one, and a raw `role`/`locationIds` diff says
 * less than "Invited as ...".
 */
const RULES: ReadonlyArray<(entry: AuditLogEntry) => AuditSummary | null> = [
    summarizeFailure,
    summarizeAccess,
    summarizeInvite,
    summarizeDiff,
    summarizeDelete,
    summarizeSet,
    summarizeFacts,
    summarizeRequestEcho,
];

/** The one-line "what happened" under an entry's action. */
export function summarizeAuditEntry(entry: AuditLogEntry): AuditSummary {
    for (const rule of RULES) {
        const summary = rule(entry);
        if (summary !== null) return summary;
    }
    return { rule: 'none', line: null, title: [] };
}

export { shortRoute } from '../route';

export { changePairs } from './diff';
export type { AuditDiffPair, AuditSummary, AuditSummaryRule } from './types';
